///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.create = abcsetup.duplicate_vendor.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.create = {

    // Variables

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('Duplicate SAP Supplier');

        // Added the button this way as opposed to a partial because adding via partial was breaking the page visually
        //$('<div id="reject-btn-dropdown" class="btn-group" role="group"> <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown"> Submit to Supplier </button> <div class="dropdown-menu dropdown-menu-right reject"> <div class="alert alert-info mx-2 text-center">Please provide a comment that will be shared with the Supplier</div><div class="dropdown-divider"></div><textarea name="reject_reason" class="form-control reject-description ml-4 required" placeholder="Comments" rows="3"></textarea> <div class="text-right mt-2"> <button class="btn btn-primary" type="submit" name="form_action" value="reject_to_vendor" title="Click to send the form to the Supplier for more information" formnovalidate>Submit to Supplier</button> </div></div></div>').insertBefore( ".btn-success");
        $('button[value="submit"]').text('Submit to Risk');
        $('button[value="submit"]').attr('formnovalidate', 'formnovalidate')

        // Bind any form element behavior
        this._bindFormElems();

    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        abcsetup.duplicate_vendor.common.bindFormElems();
    },


    /**
     * Bind any form element behavior
     */
    _bindFormElems: function () {

    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    }
}